import { ModTag } from '@moderneinc/design-system-components';
import { Stack, Typography } from '@mui/material';
import type { FunctionComponent } from 'react';
import { ModerneMarkdown } from '../utilities/markdown/markdown.component';

type RecipeSearchResultProps = {
  id: string;
  name: string;
  disableCategory?: boolean;
};

/**
 * Renders a compact recipe search result: the recipe name (with inline-code
 * markdown) followed by a language tag derived from the id (e.g. `java`).
 * Matches the marketplace search mock — no logo, no id subtitle. The full id
 * stays on the row's `title` so same-named recipes remain distinguishable on
 * hover (customer-requests #2705).
 */
export const CompactRecipeSearchResult: FunctionComponent<
  RecipeSearchResultProps
> = ({ id, name, disableCategory }) => {
  const category = id.split('.').at(2);
  return (
    <Stack
      direction="row"
      sx={{ minWidth: 0, alignItems: 'center', gap: 1, flexWrap: 'wrap' }}
    >
      <Typography
        variant="bodySm"
        title={id}
        sx={{ whiteSpace: 'break-spaces' }}
      >
        <ModerneMarkdown disableCodeFontColor>{name}</ModerneMarkdown>
      </Typography>
      {!disableCategory && category && (
        <ModTag size="medium" label={category} />
      )}
    </Stack>
  );
};
